import { z } from 'zod';

export const ApiKeyDto = z.object({
  key: z.string(),
  environmentId: z.number().nullable(),
  environmentName: z.string().nullable(),
  type: z.enum(['SDK', 'SOURCE_MAP']),
  title: z.string(),
});

export type ApiKeyDto = z.infer<typeof ApiKeyDto>;

export const GetApiKeysResponse = z.object({
  apiKeys: z.array(ApiKeyDto),
});

export type GetApiKeysResponse = z.infer<typeof GetApiKeysResponse>;
